import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAddCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.5 9.167v2.5q0 .354.24.593.24.24.593.24.354 0 .594-.24t.24-.593v-2.5h2.5q.354 0 .593-.24.24-.24.24-.594a.8.8 0 0 0-.24-.593.8.8 0 0 0-.593-.24h-2.5V5a.8.8 0 0 0-.24-.594.8.8 0 0 0-.594-.24.8.8 0 0 0-.593.24A.8.8 0 0 0 7.5 5v2.5H5a.8.8 0 0 0-.594.24.8.8 0 0 0-.24.593q0 .354.24.594t.594.24zm.833 7.5a8.1 8.1 0 0 1-3.25-.657 8.4 8.4 0 0 1-2.645-1.78 8.4 8.4 0 0 1-1.782-2.647A8.1 8.1 0 0 1 0 8.333q0-1.729.656-3.25a8.4 8.4 0 0 1 1.781-2.645A8.4 8.4 0 0 1 5.084.656 8.1 8.1 0 0 1 8.333 0q1.73 0 3.25.656a8.4 8.4 0 0 1 2.646 1.781 8.4 8.4 0 0 1 1.781 2.646 8.1 8.1 0 0 1 .657 3.25 8.1 8.1 0 0 1-.657 3.25 8.4 8.4 0 0 1-1.78 2.646 8.4 8.4 0 0 1-2.647 1.781 8.1 8.1 0 0 1-3.25.657m0-1.667q2.792 0 4.73-1.937Q15 11.125 15 8.333q0-2.79-1.937-4.729-1.938-1.937-4.73-1.937-2.79 0-4.729 1.937-1.937 1.938-1.937 4.73 0 2.79 1.937 4.729Q5.542 15 8.334 15"
    />
  </svg>
);
export default SvgAddCircleIcon;
